import { useEffect, useRef } from "react";
import { addSingleMarkers } from "./markers";
import { useNavigate } from "react-router-dom";

const DEFAULT_ZOOM = 17;

export const GoogleMap = ({
  locations,
  t,
  handleModalProps,
  setAppState
}: {
  locations: any;
  t: Function;
  handleModalProps: any;
  setAppState: any;
}) => {
  const ref: any = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (ref.current) {
      const map = new window.google.maps.Map(ref.current, {
        center: { lat: locations[0].lat, lng: locations[0].lng },
        zoom: DEFAULT_ZOOM,
        disableDefaultUI: true,
        zoomControl: true,
      })

      addSingleMarkers({ locations, map, t, handleModalProps, setAppState, navigate });
    }
  }, [ref, locations, t, handleModalProps]);

  return <div ref={ref} className="map" id="map" />
};
